import { css } from '@linaria/core'

export const elNav = css`
  min-height: 56px;
`
export const elBorderNone = css`
  border-width: 0;
  &:hover {
    border-width: 0;
  }
`
